import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-notfound',
  standalone: true,
  imports: [TranslatePipe, ButtonModule, RouterModule],
  templateUrl: './notfound.component.html'
})
export class NotFoundComponent {

}